<template>
<div v-if="this.$route.meta.breadcrumbs">
  <div class="row mb-3">
    <div class="col-md-12">
      <span class="page-path">{{$t('menu.' + this.$route.meta.serviceSlug)}} · </span><span class="page-name">{{$t('menu.' + this.$route.meta.pageName)}}</span>
    </div>
  </div>
</div>
</template>

<script>

export default {
  name: 'app-breadcrumbs',
  // computed: {
  //   currentRoute () {
  //     console.log(this.$route.meta)
  //     return this.$route.name
  //   }
  // }
}

</script>

<style lang="scss">
.page-path {
    color: #d5d5d5;
    font-weight: bold;
    font-size: 80%;
}

.page-name {
    color: $evollu-dark;
    font-weight: bold;
}
</style>
